import React from 'react';
import { Bubble, NavMenu } from 'tea-component';
import SvgIcon from '@/pages/home/components/SvgIcon';
import { getLocale, setLocale, useIntl } from 'umi';
import { LANGUAGE_CN, LANGUAGE_EN } from '@/pages/home/_config/config';
import { buriedBtnPoint } from '@home/utils/buriedPoint';

export default function locale() {
  const local = getLocale();
  const isEngish = local !== LANGUAGE_CN;
  // 切换语言触发组件刷新
  // eslint-disable-next-line react-hooks/rules-of-hooks
  useIntl();

  function handleLocale() {
    // setIsEngish(!isEngish)
    const localValue = getLocale();
    const value = localValue === LANGUAGE_CN ? LANGUAGE_EN : LANGUAGE_CN;
    buriedBtnPoint({
      buttonId: '100101001',
      extInfo: JSON.stringify({
        language: localValue === LANGUAGE_CN ? LANGUAGE_EN : LANGUAGE_CN
      }),
      pageId: '100101',
      typeId: 'homePage_pc_v2'
    });
    setLocale(value, false);
  }

  return <NavMenu.Item >
    <Bubble
      arrowPointAtCenter
      placement="bottom"
      dark
      placementOffset={20}
      content={!isEngish ? 'Switch to English' : '切换到中文'}
      overlayClassName="dba-nav-menu-overlay"
    >
      <div className='lay-nav-right' onClick={handleLocale}>
        <SvgIcon className='eg-cn' type={isEngish ? 'english' : 'chinese'} />
      </div>
    </Bubble>
  </NavMenu.Item>;
}
